import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractInsightsComponent } from '../../../contract-insights/contract-insights.component';
import { DocumentFormComponent } from '../../../document-form/document-form.component';
import { EditContractDataService } from '../../../../services/edit-contract-data.service';

@Component({
    selector: 'app-insights-tab',
    standalone: true,
    imports: [CommonModule, ContractInsightsComponent, DocumentFormComponent],
    template: `
        <div class="h-full w-full overflow-auto">
            @if (contractId() && !contract()?.containsForm) {
            <app-contract-insights class="block h-full w-full" [contractId]="contractId()"
                [role]="currentRole()" [projectId]="projectId()" [documentType]="contract()?.linkedDocType?._id || ''"
                [isEmptyDoc]="emptyDocument()" [currentWalkThroughNumber]="currentStepNumber()"
                (isEmptyDocChange)="onIsEmptyDocument($event)"
                (isRefreshingChange)="onIsRefreshing($event)"
                [tabFocused]="tabFocused"></app-contract-insights>
            }@else if(contract()?.containsForm && contract()){
            <app-document-form
                (toggleQuestionPanel)="onToggleQuestionPanel($event)"
                [contract]="contract()!" 
                [projectId]="projectId()"
                [currentTabIndex]="0"></app-document-form>
            }
        </div>
    `,
    styles: [`
        :host {
            display: block;
            height: 100%;
            width: 100%;
        }
    `]
})
export class InsightsTabComponent {
    tabFocused: boolean = true;

    constructor(public dataService: EditContractDataService) { }

    // Use getter methods to access computed signals from the service - these will auto-update!
    get contractId() { return this.dataService.contractId; }
    get contract() { return this.dataService.contract; }
    get currentRole() { return this.dataService.currentRole; }
    get projectId() { return this.dataService.projectId; }
    get emptyDocument() { return this.dataService.emptyDocument; }
    get currentStepNumber() { return this.dataService.currentStepNumber; }

    onIsEmptyDocument(event: boolean) {
        const data = this.dataService.getData();
        if (data && data.parent) {
            data.parent.isEmptyDocument(event);
        }
    }

    onIsRefreshing(event: boolean) {
        const data = this.dataService.getData();
        if (data && data.parent) {
            data.parent.onContractRefreshingChange(event);
        }
    }

    onToggleQuestionPanel(event: any) {
        const data = this.dataService.getData();
        if (data && data.parent) {
            data.parent.toggleQuestionPanel(event.showPanel, event.activeTabIndex);
        }
    }
}

